import { createTheme } from "@mui/material";

export const theme = createTheme({
  header: {
    bgcolor: "#827f7f3d",
  },
  fontSize: {
    smallText: "0.656rem",
  },
  fontWeight: {
    fontWeightMiniBold: "600",
  },
  typography: {
    fontFamily: "Inter",
  },

  components: {
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: "#827f79",
          height: 3,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "14px",
          color: "#666666",
          fontFamily: "Inter",
          fontWeight: "400",
          "&.Mui-selected": {
            color: "#252C32",
            fontWeight: "500",
            fontFamily: "Inter",
          },
        },
      },
    },
  },
});
